import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@store/baseQueries";
import {
  createUser,
  editUser,
  fetchCalenderMonths,
  fetchCompanies,
  fetchCountries,
  fetchProducts,
  fetchSectionMonths,
  fetchSectionProducts,
  fetchUsers,
  fetchYears,
} from "./queries";
import { mastersBaseUrl } from "@store/urlPaths";
import { message } from "antd";
import { getErrorMessage } from "@utils/error";

const mastersApi = createApi({
  reducerPath: "masters",
  baseQuery: baseQuery(mastersBaseUrl),
  tagTypes: ["USERS"],
  endpoints: (builder) => ({
    // fetch products
    fetchProducts: builder.query({
      query: fetchProducts,
      transformResponse: (res) => {
        res.data.sort((a, b) => a.name.localeCompare(b.name));
        return res;
      },
    }),

    // fetch section products
    fetchSectionProducts: builder.query({
      query: fetchSectionProducts,
      transformResponse: (res) => {
        res.list.sort((a, b) => a.localeCompare(b));
        return res;
      },
    }),

    // fetch section months
    fetchSectionMonths: builder.query({
      query: fetchSectionMonths,
    }),

    //fetch calender month
    fetchCalenderMonths: builder.query({
      query: fetchCalenderMonths,
    }),

    //fetch companies
    fetchCompanies: builder.query({
      query: fetchCompanies,
    }),

    //fetch countries
    fetchCountries: builder.query({
      query: fetchCountries,
    }),

    //fetch years
    fetchYears: builder.query({
      query: fetchYears,
    }),

    //fetch users
    fetchUsers: builder.query({
      query: fetchUsers,
      providesTags: ["USERS"],
    }),

    // create user
    createUser: builder.mutation({
      query: createUser,
      invalidatesTags: ["USERS"],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            message.success(data.message);
          }
        } catch (error) {
          message.error(getErrorMessage(error));
        }
      },
    }),

    // edit user
    editUser: builder.mutation({
      query: editUser,
      invalidatesTags: ["USERS"],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            message.success(data.message);
          }
        } catch (error) {
          message.error(getErrorMessage(error));
        }
      },
    }),
  }),
});

export const {
  useFetchProductsQuery,
  useFetchSectionProductsQuery,
  useFetchSectionMonthsQuery,
  useFetchCalenderMonthsQuery,
  useFetchCompaniesQuery,
  useFetchCountriesQuery,
  useFetchYearsQuery,
  useFetchUsersQuery,
  useCreateUserMutation,
  useEditUserMutation,
  reducer: mastersReducer,
  reducerPath: mastersReducerPath,
  middleware: mastersMiddleware,
} = mastersApi;
